import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from './crud.service';
import { Company, AccountStatus } from '../models/company';

@Injectable({
  providedIn: 'root',
})
export class SuperAdminCompanyService extends CrudService<Company> {
  constructor() {
    const http = inject(HttpClient);

    super(http, 'admin/companies');
  }

  async updateAccountStatus(companyId: string, accountStatus: AccountStatus) {
    const result = await this.http
      .patch<{ message: string; company: Company }>(`admin/companies/${companyId}/account-status`, { accountStatus })
      .toPromise();
    this.dataChangedSubject.next(true);
    return result;
  }

  async createCompany(data: {
    companyName: string;
    countryCode: string;
    phone?: string;
    vat?: string;
    fullName: string;
    email: string;
    password: string;
  }) {
    const result = await this.http
      .post<{ message: string; company: Company; user: any }>('admin/companies/create', data)
      .toPromise();
    this.dataChangedSubject.next(true);
    return result;
  }
}
